import { keyframes, styled } from "@givenwell/stitches";
import { easing } from "@givenwell/theme";
import { Tooltip as TooltipPrimitive } from "radix-ui";
import { ReactNode } from "react";

export function Tooltip({
  children,
  content,
  ...props
}: Omit<TooltipPrimitive.TooltipContentProps, "content"> & { children?: ReactNode; content?: ReactNode }) {
  return (
    <TooltipPrimitive.Provider delayDuration={0} disableHoverableContent>
      <TooltipPrimitive.Root>
        <TooltipPrimitive.Trigger asChild>{children}</TooltipPrimitive.Trigger>
        <TooltipPrimitive.Portal>
          <Content sideOffset={5} side="bottom" {...props}>
            {content}
          </Content>
        </TooltipPrimitive.Portal>
      </TooltipPrimitive.Root>
    </TooltipPrimitive.Provider>
  );
}

const scaleIn = keyframes({
  from: { transform: "scale(0.9)", opacity: 0 },
  to: { transform: "scale(1)", opacity: 1 },
});

const scaleOut = keyframes({
  from: { transform: "scale(1)", opacity: 1 },
  to: { transform: "scale(0.9)", opacity: 0 },
});

const Content = styled(TooltipPrimitive.Content, {
  borderRadius: 3,
  padding: "2px 8px",
  fontScale: "sm",
  maxWidth: 260,
  align: "center",
  zIndex: 2147483647,
  // weight: 500,
  lineHeight: 1.4,
  color: "white",
  backgroundColor: "rgba(0, 0, 0, 0.7)",
  animation: `${scaleOut()} 60ms ${easing.standard}`,
  "&[data-state='delayed-open'], &[data-state='instant-open']": {
    animation: `${scaleIn()} 100ms ${easing.standard}`,
  },
});
